import { useState, useEffect } from "react";
export const useQuoteCardMobile = () => {
  const [isQuoteCardMobile, setIsQuoteCardMobile] = useState(false);

  const handleJudgeClientWidth = () => {
    const isMobile =
      document.body.clientWidth < 526 ||
      (document.body.clientWidth > 769 && document.body.clientWidth < 896);
    setIsQuoteCardMobile(isMobile);
  };

  useEffect(() => {
    window.addEventListener('resize', handleJudgeClientWidth);
    handleJudgeClientWidth();
    return () => {
      window.removeEventListener('resize', handleJudgeClientWidth)
    }
  }, []);

  return isQuoteCardMobile;
}